export type CareerFilter = 'all' | 'other' | 'projects';

export function featuredCareerJobs<T extends { slug: string; canApply: boolean }>(jobs: T[]): T[] {
  const preferred = ['engineer-eventmanagement-monitoring', 'it-business-engineer-supply-chain-integration', 'java-angular-engineer-marktrechnungskontrolle'];
  const available = jobs.filter(job => job.canApply);
  const selected = preferred.flatMap(slug => available.find(job => job.slug === slug) ?? []);
  return [...selected, ...available.filter(job => !selected.some(value => value.slug === job.slug))].slice(0, 3);
}

export function normalizeCareerSearch(value: string): string {
  return value.toLocaleLowerCase('de-DE').replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function filterCareerJobs<T extends { title: string; location: string; skills: string[]; project?: { slug: string } | null; canApply: boolean }>(jobs: T[], query: string, filter: CareerFilter): T[] {
  const terms = normalizeCareerSearch(query).trim().split(/\s+/).filter(Boolean);
  return jobs.filter(job => job.canApply && (filter === 'all' || Boolean(job.project) === (filter === 'projects')) &&
    terms.every(term => normalizeCareerSearch([job.title, job.location, ...(job.skills ?? [])].join(' ')).includes(term)));
}
